import React, { useState } from "react";
import styled from "styled-components";
import { IoMdMenu } from "react-icons/io";
import LanguageSelection from "./LanguageSelection";
import { NavLink } from "react-router-dom"; // Utilisation de NavLink

const LogoImage = styled.img`
  max-width: 60px;
  width: 100%;
  margin-left: 45px;
  @media (max-width: 991px) {
    margin-left: 30px;
  }
`;

const Logo = () => (
  <NavLink to="/">
    <LogoImage loading="lazy" src="./Assets/logo.png" alt="Company Logo" />
  </NavLink>
);

const NavWrapper = styled.nav`
  display: flex;
  gap: 10px;
  font-size: 14px;
  color: #212832;
  font-weight: 500;
  justify-content: center;
  @media (max-width: 991px) {
    display: none;
  }
`;

// Utilisation de NavLink pour bénéficier de l'état actif
const NavItem = styled(NavLink)`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  cursor: pointer;
  color: #212832;
  padding: 10px 20px;
  text-decoration: none;
  display: block;
  border-radius: 10px;
  transition: background-color 0.3s, color 0.3s, transform 0.3s;
  
  &:hover {
    transform: scale(1.05);
    border: 1px solid #ff457d;
  }
  
  /* Style pour l'onglet actif */
  &.active {
    color: #ff457d;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 3px;
      background-color: #ff457d;
      border-radius: 5px;
    }
  }
  
  @media (max-width: 991px) {
    padding: 8px 16px;
    border-radius: 8px;
  }
`;

const navItems = [
  { title: "Cours", route: "/course" },
  { title: "Aloo", route: "/aloo" },
  { title: "Labs", route: "/lab" },
  { title: "Bibliothèque", route: "/library" },
  { title: "Store", route: "/store" },
  { title: "Events", route: "/event" },
  { title: "Abonnements", route: "/subscription" },
  { title: "A propos", route: "/infos" },
];

const Navigation = () => (
  <NavWrapper>
    {navItems.map((item, index) => (
      <NavItem key={index} to={item.route}>
        {item.title}
      </NavItem>
    ))}
  </NavWrapper>
);

const ActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  @media (max-width: 991px) {
    display: none;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Button = styled.button`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  transition: color 0.3s;
  &:hover {
    color: #ff457d;
  }
  @media (max-width: 991px) {
    padding: 4px;
  }
`;

const SignUpButton = styled(Button)`
  border: 1px solid #000;
  border-radius: 5px;
  padding: 6px 12px;
  &:hover {
    background-color: #000;
    color: #fff;
  }
  @media (max-width: 991px) {
    padding: 4px 8px;
  }
`;

const MobileMenuWrapper = styled.div`
  display: ${(props) => (props.isOpen ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 10px;
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 999;
  @media (min-width: 992px) {
    display: none;
  }
`;

const HeaderWrapper = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  width: 95%;
  @media (max-width: 991px) {
    padding: 5px;
  }
`;

const HamburgerButton = styled.button`
  display: none;
  color: #000;
  @media (max-width: 991px) {
    display: block;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 24px;
  }
`;

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prevMenuOpen) => !prevMenuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <HeaderWrapper>
      <Logo />
      <HamburgerButton onClick={toggleMenu}>
        <IoMdMenu />
      </HamburgerButton>
      <Navigation />
      <ActionsWrapper>
        <ActionButtons>
          <SignUpButton
            onClick={() => {
              window.open("https://app.toyaloo.africa", "_blank");
            }}
          >
            Se connecter
          </SignUpButton>
          <LanguageSelection />
        </ActionButtons>
      </ActionsWrapper>
      <MobileMenuWrapper isOpen={menuOpen}>
        {navItems.map((item, index) => (
          <NavItem key={index} to={item.route} onClick={closeMenu}>
            {item.title}
          </NavItem>
        ))}
        <SignUpButton
          onClick={() => {
            window.open("https://app.toyaloo.africa", "_blank");
          }}
        >
          Se connecter
        </SignUpButton>
        <LanguageSelection />
      </MobileMenuWrapper>
    </HeaderWrapper>
  );
};

export default Header;
